/**
 * Admin / ops display title for item requests (H7).
 * Recompose from taxonomy when possible so legacy subcategory-only rows still read well.
 */

import { categoryLabels } from "@/lib/categoryLabels";
import { getSubcategoryName } from "@/lib/listing/titleComposer";
import { composeItemRequestTitle } from "./composeRequestTitle";
import type { ItemCategory } from "@/lib/types";

export function displayItemRequestTitle(input: {
  storedTitle: string;
  category?: string | null;
  subcategory?: string | null;
}): string {
  const categoryKey = (input.category ?? "").trim();
  const categoryName =
    categoryKey && categoryKey in categoryLabels
      ? categoryLabels[categoryKey as ItemCategory]
      : categoryKey;
  const subcategoryName = getSubcategoryName(input.subcategory) ?? "";

  if (categoryName || subcategoryName) {
    const composed = composeItemRequestTitle({
      categoryName: categoryName || "",
      subcategoryName,
    });
    if (composed) return composed;
  }

  return (input.storedTitle || "").trim() || "Untitled request";
}
